import Reveal from 'components/Reveal';
import TestimonialCard from 'components/layouts/TestimonialCard';
import React from 'react';

const data = [
  {
    content:
      'Great platform for beginners and experienced investors alike. User-friendly interface, wide selection of coins and tokens, and competitive fees.',
    name: 'Vera Thomas',
    image: '/assets/images/vera.jpeg',
  },
  // {
  //   content:
  //     "",
  //   name: 'Vera Thomas',
  //   image: '/assets/images/vera.jpeg',
  // },
  {
    content:
      "I'm impressed with the customer support on this platform. They're always quick to respond to my questions and help me resolve any issues I've had.",
    name: 'Peter Anderson',
    image: '/assets/images/peter.jpeg',
  },
  {
    content:
      "I've been using this platform for over a year now and I'm very happy with it. It's secure, reliable, and offers a variety of features that make it easy to invest and trade cryptocurrencies.",
    name: 'Elizabeth',
    image: '/assets/images/elizabeth.jpeg',
  },
  {
    content:
      "This platform is constantly innovating and adding new features. It's clear that they're committed to providing their users with the best possible experience.",
    name: 'Raymond Edward',
    image: '/assets/images/raymond.jpeg',
  },
];

const Testimonial = () => {
  return (
    <Reveal>
      <div className="container mx-auto p-5">
        <div className="max-w-[750px]">
          <p className="mb-2 text-3xl text-blue-500">TESTIMONIALS</p>
          <p className="mb-2 text-[30px] md:text-[40px]">
            300,000+ HAPPY INVESTORS AROUND THE WORLD
          </p>
          <p className="text-xl text-gray-600">
            We have many happy investors investing with us. Some impresions from
            our Investors!
          </p>
        </div>

        <br />
        <div className="flex gap-x-4 overflow-x-auto pb-5">
          {data.map((item, index) => (
            <TestimonialCard
              key={index}
              testimony={item.content}
              name={item.name}
              imgUrl={item.image}
            />
          ))}
        </div>
        <div className="mx-auto w-full lg:w-[55%]">
          <TestimonialCard
            testimony="This platform stands out from the crowd, offering a unique alternative to the mainstream Blockchain.com. The variety of cryptocurrencies and the real-time market data are game changers. My portfolio has seen substantial growth, and the security measures give me peace of mind. This isn't just an investment platform, it's a dynamic community of investors. I'm excited to see where my investments will go with."
            name="Johnson Dave"
            imgUrl="/assets/images/dave.jpeg"
          />
        </div>

        <br />
      </div>
    </Reveal>
  );
};

export default Testimonial;
